<template>
  <button type="button" class="btn btn-primary btn-sm" @click="$parent.addCard(data)">Add</button>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        data: this.getNewCardDefault(this.value.type)
      }
    },
    methods: {
      getNewCardDefault(type) {
        switch (type) {
          case "DevicesWidget":
            return {
              label: 'Devices',
              type: 'DevicesWidget',
              h: 4,
              w: 4
            };
          case "IncidentsWidget":
            return {
              label: 'Incidents',
              type: 'IncidentsWidget',
              h: 4,
              w: 8
            };
          case "EnrollmentWidget":
            return {
              label: 'Enrollment',
              type: 'EnrollmentWidget',
              h: 4,
              w: 8,
            }
          default:
            return {};
        }
      }
    },
    watch: {
      'value.type': function(newValue) {
        this.data = this.getNewCardDefault(newValue);
      }
    }
  }
</script>

<style scoped>

</style>